import ProfileDetailsEntriesTableRow from './ProfileDetailsEntriesTableRow';

export default ProfileDetailsEntriesTableRow;


// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/table/row/index.js